import { createSelector } from '@reduxjs/toolkit';
import { selfBlocksSelector } from './self';

const advertisersSelector = createSelector(selfBlocksSelector, (sourcesWithPriority) => sourcesWithPriority.advertisers);

export default advertisersSelector;
